export default __webpack_public_path__ + "static/media/trackbar.70efb767.svg";